import type { VisitConsentByTokenResponse } from "../../hooks/Remote/Schedule/visit-consent-public.api";
import type { VisitorConsentContent } from "./visitor-consent-content.context";
import type { VisitorConsentDocument } from "./visitor-consent-documents.context";

export function mapVisitConsentContentFromSession(
  content: VisitConsentByTokenResponse["content"]
): VisitorConsentContent {
  return {
    title: content.title,
    subtitle: content.subtitle,
    description: content.description
  };
}

export function mapVisitConsentDocumentsFromSession(
  documents: VisitConsentByTokenResponse["documents"]
): VisitorConsentDocument[] {
  return [...documents]
    .sort((a, b) => a.order - b.order)
    .map(document => ({
      id: document.id,
      order: document.order,
      title: document.title,
      description: document.description,
      body: document.body,
      fileName: document.fileName,
      fileViewerUrl: document.fileViewerUrl
    }));
}
